<template>
  <v-row>
    <v-col cols="12">
      <h1>Сортировка блюд</h1>
    </v-col>
    <v-col cols="12">
    <v-tabs v-model="tab" class="mb-6" show-arrows>
      <v-tab v-for="category in categories" :key="category.id" @change="changeCategory(category.id)">{{ category.name }}</v-tab>
    </v-tabs>
      <v-data-table no-data-text="Нет блюд"
                    no-results-text="По заданному запросу ничего не найдено"
                    :headers="headers"
                    :items="products"
                    :options.sync="options"
                    :header-props="{sortIcon: 'icon-custom-arrow'}"
                    :footer-props="footerProps"
                    :loading="loading"
                    :items-per-page="100"
                    loading-text="Загрузка блюд... Подождите пожалуйста"
      >
        <template v-slot:body="props">
          <draggable
                  :list="props.items"
                  @end="endDrag(props.items)"
                  tag="tbody"
          >
            <tr
                    v-for="(item, index) in props.items"
                    :key="index"
            >
              <td>
                <v-icon
                        small
                        class="page__grab-icon"
                >
                  mdi-arrow-all
                </v-icon>
              </td>
              <td> {{ item.name }} </td>
              <td> {{ item.category.name }} </td>
              <td>
              <span v-for="tag in item.tags">{{ tag.name }}
                {{ tag == item.tags[item.tags.length - 1] ? '' : ', ' }}
              </span>
              </td>
              <td> {{ item.price }} </td>
            </tr>
          </draggable>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
    import draggable  from 'vuedraggable'
    import CategoryService from "../../api/CategoryService";
    import ProductService from "../../api/ProductService";
export default {
  name: 'HomeIndex',
  components: { draggable },
  data: () => ({
      tab: 0,
      options: {},
      footerProps: {
          itemsPerPageText: 'Блюд на страницу',
          pageText: '{0}-{1} из {2}',
          itemsPerPageAllText: 'Все',
          itemsPerPageOptions: [100]
      },
      headers: [
          {
              width: '1%',
              sortable: false
          },
          {
              text: 'Блюдо',
              value: 'product.name',
              sortable: false
          },
          {text: 'Категория', value: 'product.category.name', sortable: false},
          {
              text: 'Теги',
              value: 'product.tag',
              sortable: false
          },
          {
              text: 'Цена',
              value: 'product.price',

          },
      ],

      loading: false,
      products: [],
      categories: [],
  }),
  mounted() {

    CategoryService.list().then(response => {
        this.categories = response.data
        this.changeCategory(this.categories[0].id)
    })

  },
  watch: {},
  methods: {
      endDrag(items){
          let params = {items: items}
           ProductService.updateSort(params).then(response => {

           })
      },
      changeCategory(id){
          this.loading =  true
          let params = {
              category: id,
              withChildren: true,
              type: 0,
              perPage: 100,
          }
          ProductService.list(params).then(response => {
              this.products = response.data.data
              this.loading = false
          })
      },
  },
}
</script>

<style lang="scss" scoped>
  .page__grab-icon{
    &:hover{
      cursor: move;
    }
  }
</style>
